export enum enumExternalQuoteState {
  EXTERNAL_CREATED,
  EXTERNAL_ACCESSED,
}
